import { memo } from 'react'
import { usePress } from '@react-aria/interactions'
import cn from 'classnames'

import { Text } from '~/shared/ui/Text'

import type { TabBarItem, TabBarProps } from './types'

import styles from './TabBar.module.scss'

const Tab = memo(function Tab(props: {
  item: TabBarItem
  isActive: boolean
  onSelect: (key: string) => void
}) {
  const { item, isActive, onSelect } = props
  const { pressProps, isPressed } = usePress({ onPress: () => onSelect(item.key) })

  return (
    <button
      className={cn(styles.tab, isActive && styles.tab_ACTIVE)}
      type='button'
      data-pressed={isPressed}
      aria-current={isActive || undefined}
      aria-label={item.label}
      {...pressProps}
    >
      <span className={styles.iconSlot}>
        {item.icon}
        {item.badge && <span className={styles.badge} />}
      </span>
      <Text variant='TAB' color='INHERIT'>
        {item.label}
      </Text>
    </button>
  )
})

/**
 * Меню-остров: 5 вкладок, высота 64, радиус 24. Навигацию не делает —
 * только сообщает о выборе через onSelect(activeKey решает вызывающий код).
 */
export const TabBar = memo(function TabBar(props: TabBarProps) {
  const { items, activeKey, onSelect } = props

  return (
    <nav className={styles.root} aria-label='Основная навигация'>
      {items.map((item) => (
        <Tab key={item.key} item={item} isActive={item.key === activeKey} onSelect={onSelect} />
      ))}
    </nav>
  )
})
